import type { TicketHold as GQLItem } from '../../../generated/api.graphql';
import { take } from '../../../util';

/** Tickets held back from sale; a hold is a blueprint on the backend, but `ticketBlueprints` leaves it out. */
export type TicketHold = {
  id: number;
  eventId: number;
  name: string;
  quantity: number;
  orderPriority: number;
  /** The ticket whose allotment the hold draws from. */
  sourceTicketId: number;
  description: string | null;
};

export const fromGql = (item: GQLItem): TicketHold => ({
  ...take<TicketHold>(item, 'id', 'eventId', 'name', 'quantity', 'orderPriority', 'sourceTicketId'),
  description: item.description ?? null,
});
